<template>
    <div class="bg-grey-lightest rounded-2xl flex flex-row text-left items-center relative shadow-md">
        <div class="bg-primary w-6 h-full rounded-l-2xl"></div>
        <div class="p-10 text-4xl text-primary font-bold uppercase">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'v-ticketcard',
    components: {
        
    },
    methods: {
    }

};
</script>

<style scoped>

</style>